import { render, staticRenderFns } from "./DashboardClientList.vue?vue&type=template&id=76a3cc2c&"
import script from "./DashboardClientList.vue?vue&type=script&lang=js&"
export * from "./DashboardClientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports